define('app/models/vendor_deal_req_model',['app/setup'], function(takhfifan) {
  takhfifan.vendorDealReqModel = Backbone.Model.extend({
    validation: {
      'email': [{
          required: true,
          msg: i18n.t('email_missing')
        }, {
          pattern: 'email',
          msg: i18n.t('email_invalid')
      }],
      'telephone': function (value, key, fields) {
        var pat = new RegExp(/(09)[123]\d+$/);
          if(!pat.test(value) && value.length != 0) {
            return i18n.t('telephone_invalid')
          }
          else if(value.length > 0 && value.length != 11) {
            return i18n.t('telephone_range')
          }
      }
    }
  });
});

